import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, TextField } from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';

import useDataGetter from '../../hooks/useDataGetter';
import { Context } from '../../context/DataContext';
import SelectField from '../../components/form/SelectField';

const ClientInfoPage = () => {
  const navigate = useNavigate();
  const { data = [] } = useDataGetter(
    `${process.env.REACT_APP_ACEMUSE_API_URL}/getTwAddress`,
    {}
  );
  const { state, saveExtProfile, setCustomerInfo } = React.useContext(Context);
  const { customerInfo } = state;
  const [errorMsg, setErrorMsg] = React.useState('');
  const [loading, setLoading] = React.useState(false);
  const [values, setValues] = React.useState({
    name: customerInfo.name || '',
    mobile: customerInfo.phone || '',
    email: customerInfo.email || '',
    city: customerInfo.city || '',
    zip_code: customerInfo.zip_code || '',
    district: customerInfo.district || '',
    address: customerInfo.restAddress || '',
  });

  const { name, mobile, email, city, zip_code, district, address } = values;

  const handleChange = (prop) => (e) =>
    setValues({ ...values, [prop]: e.target.value });

  return (
    <Box>
      <Typography
        variant='h4'
        sx={{ my: 2 }}>
        客戶資料
      </Typography>
      <Box
        component='form'
        sx={{ px: 3, pb: 8, '& > div': { my: 1 } }}
        noValidate='off'>
        <TextField
          fullWidth
          id='client-name'
          label='姓名'
          value={name}
          onChange={handleChange('name')}
        />
        <TextField
          fullWidth
          id='client-mobile'
          label='行動電話'
          value={mobile}
          inputProps={{
            inputMode: 'numeric',
          }}
          onChange={handleChange('mobile')}
        />
        <TextField
          fullWidth
          id='client-email'
          label='信箱'
          value={email}
          onChange={handleChange('email')}
        />
        {data.length ? (
          <SelectField
            fullWidth
            id='address-city'
            label='縣市'
            placeholder='請選擇...'
            value={city}
            onChange={(e) => {
              setValues({
                ...values,
                city: e.target.value,
                district: '',
                zip_code: '',
              });
            }}
            options={data.map(({ name, id }) => ({
              id: `city_${id}`,
              value: name,
              text: name,
            }))}
          />
        ) : null}
        {data.length && city ? (
          <SelectField
            fullWidth
            id='address-district'
            label='鄉鎮市區'
            placeholder='請選擇...'
            value={!zip_code || !district ? '' : `${zip_code}_${district}`}
            onChange={(e) => {
              const [zip_code, district] = e.target.value.split('_');
              setValues({ ...values, district, zip_code });
            }}
            options={data
              .find(({ name }) => name === city)
              .districs.map(({ name, zip_code }) => ({
                id: `district_${zip_code}`,
                value: `${zip_code}_${name}`,
                text: name,
              }))}
          />
        ) : null}
        {data.length && district ? (
          <TextField
            fullWidth
            id='client-address'
            label='地址'
            value={address}
            onChange={handleChange('address')}
          />
        ) : null}
        {errorMsg ? (
          <Typography
            variant='h6'
            sx={{ my: 2, color: 'red' }}>
            {errorMsg}
          </Typography>
        ) : null}
        <LoadingButton
          variant='contained'
          sx={{ width: 168, mt: 3 }}
          loading={loading}
          onClick={() => {
            // navigate('/extend-new/mobile-verify');
            setErrorMsg('');
            if (!name || !mobile || !email) {
              setErrorMsg('請輸入資料');
            } else {
              setLoading(true);
              const customerAddress = `${zip_code}${city}${district}${address}`;

              saveExtProfile(
                {
                  orderId: customerInfo.orderId,
                  name,
                  phone: mobile,
                  email,
                  address: customerAddress,
                },
                ({ responseCode, responseMsg }) => {
                  if (responseCode === '000') {
                    setCustomerInfo(
                      {
                        phone: mobile,
                        name,
                        email,
                        address: customerAddress,
                        city,
                        zip_code,
                        district,
                        restAddress: address,
                      },
                      () => {
                        setLoading(false);
                        navigate('/extend-new/mobile-verify');
                      }
                    );
                  } else {
                    setLoading(false);
                    setErrorMsg(responseMsg);
                  }
                }
              );
            }
          }}>
          下一步
        </LoadingButton>
      </Box>
    </Box>
  );
};

export default ClientInfoPage;
